import { render, staticRenderFns } from "./ColorButtonView.vue?vue&type=template&id=6d09bfde&scoped=true&"
import script from "./ColorButtonView.vue?vue&type=script&lang=ts&"
export * from "./ColorButtonView.vue?vue&type=script&lang=ts&"
import style0 from "./ColorButtonView.vue?vue&type=style&index=0&id=6d09bfde&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d09bfde",
  null
  
)

export default component.exports